import React from 'react';
import Icon from '../Icon';

const STATES = [
  { abbr: 'CA', name: 'California', program: 'IHSS / Medi-Cal', pay: '$2,000–$4,500 / mo' },
  { abbr: 'AZ', name: 'Arizona',    program: 'AHCCCS / ALTCS',  pay: '$1,800–$3,800 / mo' },
  { abbr: 'TX', name: 'Texas',      program: 'CDS Program',     pay: '$1,800–$3,500 / mo' },
  { abbr: 'NY', name: 'New York',   program: 'CDPAP',           pay: '$2,400–$4,200 / mo' },
  { abbr: 'FL', name: 'Florida',    program: 'SMMC-LTC',        pay: '$1,600–$3,200 / mo' },
  { abbr: 'IL', name: 'Illinois',   program: 'CCP / DRS',       pay: '$1,800–$3,400 / mo' },
  { abbr: 'PA', name: 'Pennsylvania', program: 'CHC Program',   pay: '$2,000–$3,800 / mo' },
  { abbr: 'OH', name: 'Ohio',       program: 'PASSPORT Waiver', pay: '$1,600–$3,200 / mo' },
  { abbr: 'MI', name: 'Michigan',   program: 'MI Choice',       pay: '$1,800–$3,500 / mo' },
  { abbr: 'GA', name: 'Georgia',    program: 'CCSP / SOURCE',   pay: '$1,500–$3,000 / mo' },
  { abbr: 'NC', name: 'North Carolina', program: 'CAP/DA',      pay: '$1,600–$3,100 / mo' },
  { abbr: 'WA', name: 'Washington', program: 'COPES / IPC',     pay: '$2,000–$3,800 / mo' },
];

const StatesGrid = ({ onCTA }) => (
  <section className="section-states" id="states">
    <div className="container">
      <div className="section-head center">
        <span className="eyebrow eyebrow-coral"><Icon name="map" size={12} stroke={2.4}/> All 50 states</span>
        <h2 className="section-title">
          What states <em>pay you</em> to care for a loved one?
        </h2>
        <p className="section-lede">
          Almost every state has a Medicaid Self-Directed program. Here's a sample of what a few look like —
          we'll match you to yours.
        </p>
      </div>

      <div className="states-grid">
        {STATES.map(s => (
          <div className="state-card reveal" key={s.abbr}>
            <div className="state-abbr">{s.abbr}</div>
            <div className="state-body">
              <div className="state-name">{s.name}</div>
              <div className="state-prog">{s.program}</div>
              <div className="state-pay">{s.pay}</div>
            </div>
          </div>
        ))}
      </div>

     
    </div>
  </section>
);

export default StatesGrid;
